import { useGyymClient } from '@gyym/sdk-react'
import { useSnackbar } from '@gyym/ui'
import * as Sentry from '@sentry/nextjs'
import React from 'react'

export const useResendVerificationEmail = (intended = '/') => {
  const client = useGyymClient()
  const { openSnackbar } = useSnackbar()

  return React.useCallback(async () => {
    try {
      await client.auth.user.resendEmail({ intended })
      openSnackbar({
        message: '認証メールを再送信しました',
        variant: 'success',
      })
    } catch (e) {
      Sentry.captureException(e)
      openSnackbar({
        message: '認証メールの再送に失敗しました',
        variant: 'error',
      })
    }
  }, [client.auth.user, openSnackbar, intended])
}
